import { Option } from "components/styled/async-search-select-v2/AsyncSearchSelectV2.types";

const normalizeStringArray = (values?: string[] | null): string[] => {
  if (!Array.isArray(values)) {
    return [];
  }

  return values
    .filter((value): value is string => typeof value === "string")
    .map((value) => value.trim())
    .filter(Boolean);
};

export const mapStringsToOptions = (values?: string[] | null): Option[] => {
  return Array.from(new Set(normalizeStringArray(values))).map((value) => ({
    label: value,
    value: value,
  }));
};

export const mapSelectionToStrings = (value: Option | Option[] | null): string[] => {
  const selectedValues = Array.isArray(value) ? value : value ? [value] : [];

  return selectedValues
    .map((selectedValue) => selectedValue?.value || selectedValue?.label)
    .filter(Boolean);
};

export const formatSelectionList = (values?: string[] | null, fallback = "—"): string => {
  const formattedValue = normalizeStringArray(values).join(", ");

  return formattedValue || fallback;
};
